// Tracks auth attempts that should run post-login UI after completion.

const SESSION_KEY = 'authCompletionPending';

export function markAuthCompletionPending(): void {
  sessionStorage.setItem(SESSION_KEY, 'true');
}

export function consumeAuthCompletionPending(): boolean {
  const isPending = sessionStorage.getItem(SESSION_KEY) === 'true';
  sessionStorage.removeItem(SESSION_KEY);
  return isPending;
}
